import React, { useState } from "react";
import TextTitle from "../common/ui/typography/TextTitle";
import Button from "../common/ui/buttons/Button";
import { useInfiniteQuery, useQuery } from "react-query";
import { statistics } from "../../api/statistics";
import { useGlobalStore } from "../../store";
import "./style.scss";
import { TableColumn } from "../common/Table/TableTypes";
import moment from "moment";
import Table from "../common/Table/Table";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import { ForceUpdateItem } from "../../api/statistics/types";
import NavigationDrawer from "../common/ui/navigationDrawer/NavigationDrawer";
import DrawerView from "../common/ui/navigationDrawer/DrawerView";
import ForceUpdateDriversAndVehiclesList from "./ForceUpdateDriversAndVehiclesList";
import CustomPagination from "../common/ui/Pagination/CustomPagination";

export const ForceUpdate = () => {
  const selectedCompany = useGlobalStore((state) => state.selectedCompany);
  const [isDrawerOpen, setIsDrawerOpen] = useState("");
  const [companyId, setCompanyId] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;

  const { data, isLoading, refetch } = useQuery(
    ["force-update-list", selectedCompany, currentPage],
    () =>
      statistics.getUsersByEld({
        eldType: selectedCompany,
        page: currentPage,
        perPage,
      }),
    {
      enabled: !!selectedCompany,
      keepPreviousData: true,
    },
  );

  const totalCount = data?.count ?? 0;
  const totalPages = Math.ceil(totalCount / perPage);

  const allItems =
    data?.data.map((item: ForceUpdateItem) => ({
      ...item,
      createdAt: moment(item.createdAt).format("MMM D, YYYY hh:mm A"),
    })) ?? [];

  const onClickRow = (item: ForceUpdateItem) => {
    setIsDrawerOpen(item.id);
  };

  const columns: TableColumn<ForceUpdateItem>[] = [
    { header: "Android", accessor: "androidVersion", clickRow: onClickRow },
    { header: "iOS", accessor: "iosVersion", clickRow: onClickRow },
    { header: "Companies", accessor: "companiesCount", clickRow: onClickRow },
    { header: "User Count", accessor: "userCount", clickRow: onClickRow },
    { header: "By", accessor: "createdBy", clickRow: onClickRow },
    { header: "Date", accessor: "createdAt", clickRow: onClickRow },
  ];

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  return (
    <div>
      <div className={"force-update__header d-flex align-items-center"}>
        <TextTitle level={"large"} className="d-flex align-center gap-2">
          Force Update
        </TextTitle>
        <div style={{ marginLeft: "auto" }} className={"d-flex gap-2"}>
          <Button
            main
            to={"/force-update/create"}
            beforeIcon={"plus"}
            beforeClass="force-update__button"
          >
            <span className="force-update__button--text">Add new update</span>
          </Button>
          <Button
            beforeIcon={"arrow-clockwise"}
            onClick={() => refetch()}
            beforeClass="force-update__button"
          >
            <span className="force-update__button--text">Refresh</span>
          </Button>
        </div>
      </div>

      <div className="force-update__table mt-4">
        <Table columns={columns} data={allItems} isLoading={isLoading} />
      </div>

      {/* Pagination buttons */}
      <div className="force-update__pagination mt-4">
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>

      <NavigationDrawer
        modelValue={!!isDrawerOpen || !!companyId}
        onUpdateModelValue={() =>
          companyId ? setCompanyId(0) : setIsDrawerOpen("")
        }
        width="1248px"
      >
        <DrawerView
          closeDrawer={() =>
            companyId ? setCompanyId(0) : setIsDrawerOpen("")
          }
          header={({ closeDrawer }) => (
            <div className={"d-flex align-items-center w-100"}>
              <TextTitle level={"1"} className="d-flex align-center gap-2">
                Force Update
              </TextTitle>
              <div style={{ marginLeft: "auto" }}>
                <Button
                  size={"xs"}
                  onClick={closeDrawer}
                  beforeIcon={"dismiss"}
                  beforeClass="mr-0"
                />
              </div>
            </div>
          )}
        >
          {isDrawerOpen && (
            <ForceUpdateDriversAndVehiclesList
              id={isDrawerOpen}
              setCompanyId={setCompanyId}
              companyId={companyId}
            />
          )}
        </DrawerView>
      </NavigationDrawer>
    </div>
  );
};
